import axios from 'axios';

function Client() {
	const instance = axios.create({
		baseURL: process.env.REACT_APP_API_ENV,
		headers: {
            'Content-Type': 'application/json',
        }
	});
	instance.interceptors.request.use(async (config) => {
		return config;
	 }, function (error) {
		return Promise.reject(error);
	 });
	return instance;
}

export default Client();